import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { resolveFunnelUrlByMonetizationTest } from '@/helpers';
import { landingAiRelightConfig } from '@/data/landingConfig/landingAiRelightConfig';
import { MONETIZATION_TEST } from '@/constants';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiRelight } from './schemaObject';

interface Props {}
const AiRelight: React.FC<Props> = () => {
	const funnelUrl = resolveFunnelUrlByMonetizationTest(
		{
			[MONETIZATION_TEST.NON_TIER_1]:
				GenerateLandingLinkService.funnelAiRelightV1,
		},
		GenerateLandingLinkService.funnelAiRelight,
	);
	return (
		<>
			<AggregateSchema schema={schemaObject_AiRelight} />
			<LandingTemplate
				data={landingAiRelightConfig}
				funnelLinkService={funnelUrl}
			/>
		</>
	);
};

export default AiRelight;
